(ns splash.ui.lender-portal.browser
  "The namespace responsible for loading the application in a browser"
  (:require
    ["@azure/msal-react" :as msal-react]
    ["react-router-dom" :as rrd]
    [reagent.core :as r]
    [reagent.dom :as d]
    [splash.ui.lender-portal.common.auth :as auth]
    [splash.ui.lender-portal.datadog :as datadog]
    [splash.ui.lender-portal.optimizely :as optimizely]
    [splash.ui.lender-portal.routes :as routes]
    [splash.ui.lender-portal.state :as state]
    [splash.ui.lender-portal.views.pages.login :as login]))

(def functional-compiler (r/create-compiler {:function-components true}))

;; Setting the default compiler to functional-compiler means we don't need to
;; convert components with hooks to function components with the `:f>` macro.
(r/set-default-compiler! functional-compiler)

(set! *warn-on-infer* true)

(defn auth-wrapped-body
  []
  [:<>
   [:> msal-react/UnauthenticatedTemplate
    [login/view]]
   [:> msal-react/AuthenticatedTemplate
    [routes/v1]]])

(defn app
  [msal-instance]
  [:<>
   (datadog/start-session-replay-recording)
   [:> msal-react/MsalProvider
    {:instance msal-instance}
    [auth-wrapped-body]]])

(defn root
  [msal-instance state]
  [state/with-state state
   (let [optimizely-client (r/cursor state [:optimizely-client])]
     (optimizely/optimizelyProvider
       @optimizely-client
       "foo" ; default user
       [:<>
        (datadog/datadog-rum-init)
        (datadog/set-global-context-property "team" "Instant")
        [:> rrd/BrowserRouter
         [app msal-instance]]]))])

(def el (.getElementById js/document "app"))

;; `defonce `is needed to prevent wiping it away on hot-reloading.
(defonce initial-state
  (r/atom state/initial-state))

(defn render-app
  [msal-instance]
  (d/render [root msal-instance initial-state] el functional-compiler))

(defn ^:dev/after-load render!
  []
  (-> (auth/initialize-msal-instance)
    (.then
      render-app)))

(defn ^:export run
  "The function which the browser runs on page load."
  []
  (render!))
